export default "__VITE_ASSET__C4au3vKT__"